import i18next from 'i18next';

export const getBuildingDefaultTitle = (buildingIndex: number): string =>
  i18next.t('Building') + ' ' + (buildingIndex + 1);
